import { Image, Text, VStack } from '@chakra-ui/react';
import { t } from 'i18next';
import { EmptyViewExternalLink } from '~components/EmptyView';
import prostore from '~components/ui/assets/prostore.png';

export function AddFirstAppCard() {
  return (
    <VStack spacing={3} textAlign="center">
      <Image src={prostore} alt="Prostore" w="100px" h="auto" />
      <Text fontSize="2xl" fontWeight="semibold" pt={2}>
        {t('addFirstAppFromProstore')}
      </Text>
      <Text fontSize="md" color="gray.600" maxW="360px">
        {t('selectAppsFromProstore')}
      </Text>
      <EmptyViewExternalLink label={t('waveProstore')} href={process.env.REACT_APP_PROSTORE_APPS} />
    </VStack>
  );
}
